import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Login from '../../views/Login'
import DefaultLayout from '../../layout/DefaultLayout'
import { selectIsAuthenticated } from '../../slices/authSlice'

//eslint-disable-next-line
const PrivateRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for cookie on initial load to prevent flash
    const hasAuthCookie = document.cookie.includes('access_token')

    // Short delay to allow auth state to be checked
    const timer = setTimeout(() => {
      setLoading(false)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  if (loading) {
    return (
      <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
      </div>
    )
  }

  return isAuthenticated ? <DefaultLayout /> : <Login />
}

export default PrivateRoute
